import dayjs from 'dayjs'
import { nil } from 'util/null'

export function parseDate(text?: string | nil): Date | undefined {
  if (!text) return undefined
  try {
    return new Date(text)
  } catch (error) {
    console.error('parse date failed', text, error)
    return undefined
  }
}

export function formatDate(date: Date | number, format?: string): string
export function formatDate(date: Date | number | nil, format?: string): undefined
export function formatDate(date: Date | number | nil, format = 'YYYY-MM-DD'): string | undefined {
  return date ? dayjs(date).format(format) : undefined
}

export function formatDateTime(date: Date | number): string
export function formatDateTime(date: Date | number | nil): string | undefined
export function formatDateTime(date: Date | number | nil): string | undefined {
  return formatDate(date, 'YYYY-MM-DD HH:mm')
}
